import type { OrderItem } from "@/types/types.d";
import ResultCard from "./ResultCard";
import PhotosSearcherMobile from "../components/PhotosSearcher.mobile";
import TerciaryButton from "@/components/buttons/terciary-button/TerciaryButton";
import Pagination from "@/components/Pagination/Pagination";
import { useState } from "react";
import PhotosDetailMobile from "./photos/PhotoDetailMobile";

interface PaginationRsults {
  lastPage: number;
  page: number;
  changePage: (newPage: number) => void;
}

const PhotosResultsMobile = ({
  filters,
  handleFiltersChange,
  data,
  cleanData,
  pagination,
}: {
  filters: any;
  handleFiltersChange: (new_filters: any) => void;
  data: OrderItem[];
  cleanData: () => void;
  pagination: PaginationRsults;
}) => {
  const { lastPage, page, changePage } = pagination;
  const [photo, setPhoto] = useState<OrderItem | null>(null);

  const handlePhotoClick = (item: OrderItem) => {
    setPhoto(item);
  };

  const cleanPhoto = () => {
    setPhoto(null);
  };

  if (data.length === 0) {
    return (
      <PhotosSearcherMobile
        initialFilters={filters}
        onSearch={handleFiltersChange}
      />
    );
  }

  if (photo) {
    return <PhotosDetailMobile photo={photo} cleanPhoto={cleanPhoto} />;
  }

  return (
    <div data-testid="photos-results-mobile" className="pb-4">
      <div className="flex">
        <div>
          <TerciaryButton
            iconClassName="size-5"
            icon="arrowLeft"
            label={"Nueva búsqueda"}
            colour={"black"}
            onClick={cleanData}
          />
        </div>
      </div>
      {data && data.length > 0 ? (
        <div className="grid gap-2">
          {data.map((item, index) => (
            <ResultCard
              key={item.id + "-" + index}
              item={item}
              onClick={handlePhotoClick}
            />
          ))}
          {lastPage > 1 ? (
            <div className="mt-4">
              <Pagination
                lastPage={lastPage}
                currentPage={page + 1} // backend is 0-based
                changePage={changePage}
              />
            </div>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default PhotosResultsMobile;
